const DrupalOAuth = require("./DrupalOAuth");

module.exports = function handleLogout(authContext) {
	const [state, dispatch] = authContext;
	const auth = new DrupalOAuth(state);
	const loggedOut = auth.logoutUser();
	//updates the state which forces a re render which will force the user off the page
	if (loggedOut) {
		dispatch({
			type: "LOGOUT_USER",
			payload: {
				isAuthenticated: false,
				clientId: null,
				baseUrl: null,
			},
		});
	}
	return loggedOut;
};
